(function (scope) {

scope.HomePageBanner = function () {
	var me = this;
	if ($('.HomePage').length) {
		$(window).on('resize', throttle(function() {
			
			var $banner = $(".hero-banner-items-extension");

			var windowHeight = $(window).height();
			var windowWidth = $(window).width();

			var headerHeight = $("header").outerHeight();
			var iconHeight = $(".icon-links-extension").outerHeight();
			var bannerHeight = $banner.outerHeight();
			if ($banner.attr('data-initial-height')) {
				bannerHeight = parseFloat($banner.attr('data-initial-height'));
			} else {
				$banner.attr('data-initial-height', bannerHeight);
			}
			
			if (windowHeight > windowWidth) { // portrait view
				if (windowWidth >= 640) {
					$banner.height(windowHeight - headerHeight - iconHeight);
				} else {
					$banner.height(windowHeight - headerHeight);
				}
			} else if (windowHeight > parseFloat(headerHeight + bannerHeight + (iconHeight / 3 * 2))) {
				$banner.height(windowHeight - headerHeight - iconHeight);
			} else {
				$banner.height(windowHeight - headerHeight);
			}
			
		}, 300)).resize();
	}
};

}) (window);
